import { useNavigate } from 'react-router';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { EnhancedSituationalPacks } from '../components/EnhancedSituationalPacks';

export default function SituationalPacks() {
  const navigate = useNavigate();
  const subscription = localStorage.getItem('tension_subscription') || 'free';

  return (
    <div className="min-h-screen tension-page-bg">
      {/* Header */}
      <div className="bg-white border-b border-neutral-200 px-6 py-4">
        <div className="max-w-2xl mx-auto flex items-center gap-4">
          <button
            onClick={() => navigate('/home')}
            className="p-2 hover:bg-neutral-100 rounded-lg transition-colors"
          >
            <ArrowLeft className="w-5 h-5 text-neutral-600" />
          </button>
          <div className="flex-1">
            <h1 className="text-xl font-light">Situational Packs</h1>
            <p className="text-xs text-neutral-500 mt-1">
              Specialized action plans for specific situations
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-6 py-12">
        <EnhancedSituationalPacks tier={subscription as any} />
      </div>
    </div>
  );
}
